import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Catalog from './catalog.jsx';
import ModalWindow from './modal.jsx';
import { apiFetch } from '../../../utils/api.js';

export function Edit() {
  const initialFormState = {
    title: '', description: '', price: 0, image: null, type: '',
  };

  const[show, setShow] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [cards, setCards] = useState([]);

  const isChanged = () => JSON.stringify(formData) !== JSON.stringify(initialFormState);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleShow = () => setShow(true);

  const handleClose = () => {
    if (isChanged()) {
      if (window.confirm('Данные не сохранены. Закрыть окно?')) {
        setShow(false);
        setFormData(initialFormState); // Сброс в исходное состояние
      }
    } else {
      setShow(false);
      setFormData(initialFormState);
    }
  };

  const handleImage = (e) => setFormData(prev => ({ ...prev, image: e.target.files[0] }));

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append('title', formData.title);
      data.append('description', formData.description);
      data.append('price', formData.price);
      data.append('type', formData.type || '');
      if (formData.category_id) data.append('category_id', formData.category_id);
      if (formData.image) data.append('image', formData.image);

      const res = await apiFetch('/api/cards', { method: 'POST', body: data });
      if (res.ok) {
        setShow(false);
        setFormData(initialFormState);
        fetchCards();
      } else {
        alert("Ошибка при сохранении карточки");
      }
    } catch (err) {
      console.error("Ошибка сети:", err);
    }
  };

  const fetchCards = async () => {
    try {
      const response = await apiFetch('/api/cards');
      if (response.ok) {
        const jsonData = await response.json(); 
        setCards(jsonData);
      }
    } catch (err) {
      console.error("Ошибка загрузки карточек:", err);
    }
  };

  useEffect(() => { fetchCards(); },[]);

  return (
    <div>
      <div className='d-flex mx-0 px-0 w-100 justify-content-center'>
        <h1>Редактирование каталога</h1> 
      </div>
      <div className="mb-3">
        <Button variant={'success'} onClick={handleShow}>Добавить</Button>
      </div>
      <ModalWindow show={show} handleClose={handleClose} formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} handleImage={handleImage} title='Создание карточки'/>
      <div className='w-100'>
        <Catalog cards={cards} onUpdate={fetchCards}/>
      </div>
    </div>
  );
}
